import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import useAxios from 'axios-hooks';
import {
	differenceInDays,
	formatDistanceToNow,
	startOfDay,
	subDays,
} from 'date-fns';

import FullscreenToggle from '../components/FullscreenToggle';
import TimelinePanel from './TimelinePanel';
import face1 from '../../../../../img/faces/face-1.svg';
import face2 from '../../../../../img/faces/face-2.svg';
import face3 from '../../../../../img/faces/face-3.svg';
import face4 from '../../../../../img/faces/face-4.svg';
import face5 from '../../../../../img/faces/face-5.svg';

const getWellnessFace = (scale) => {
	if (scale == 1) {
		return face1;
	} else if (scale == 2) {
		return face2;
	} else if (scale == 3) {
		return face3;
	} else if (scale == 4) {
		return face4;
	}
	return face5;
};

const JournalHistory = ({ onExpand, onContract, patientId }) => {
	const [transactions, setTransactions] = useState([]);
	const [
		{
			data: journalTransactions,
			loading:
				isJournalTransactionsLoading /* error: journalTransactionsError */,
		},
	] = useAxios({
		url: '/healthJournalTransactions',
		params: {
			filter: JSON.stringify({
				where: {
					and: [
						{
							patientId,
						},
						{
							update_dttm: {
								gt: subDays(startOfDay(new Date()), 90),
							},
						},
					],
				},
				order: 'update_dttm DESC',
			}),
		},
	});
	const [
		{ data: problems, loading: isProblemsLoading /* error: problemsError */ },
	] = useAxios(`/patients/${patientId}/problems`);
	const [
		{
			data: healthJournals,
			loading: isHealthJournalsLoading /* error: healthJournalsError */,
		},
	] = useAxios(`/patients/${patientId}/healthjournals`);

	useEffect(() => {
		if (
			!isJournalTransactionsLoading &&
			!isProblemsLoading &&
			!isHealthJournalsLoading
		) {
			setTransactions([]);
			const today = startOfDay(new Date());
			let previous,
				tracker = 0; /* , problem */
			journalTransactions.forEach((journalTransaction, index) => {
				const updateDate = startOfDay(new Date(journalTransaction.update_dttm));
				if (index === 0) {
					if (differenceInDays(today, updateDate) >= 1) {
						journalTransaction.separatorLabel = formatDistanceToNow(
							new Date(journalTransaction.update_dttm)
						);
						tracker = 0;
					}
				} else {
					if (
						differenceInDays(new Date(previous.update_dttm), updateDate) >= 1
					) {
						journalTransaction.separatorLabel = formatDistanceToNow(
							new Date(journalTransaction.update_dttm)
						);
						tracker = 0;
					}
				}
				if (journalTransaction.type === 'journal') {
					// TODO var JournalStructure = require('app/models/journal-structure.json');
					// if (item.journal_type) { // valid journal entry
					// 	// look up journal group and get friendly labels
					// 	group = _.findWhere(JournalStructure, {
					// 		type: item.journal_type
					// 	});
					// 	if (group) {
					// 		item.groupLabel = group.label;
					// 		if (group.options) {
					// 			option = _.findWhere(group.options, {
					// 				type: item.journal_detail
					// 			});
					// 			item.optionLabel = option.label;
					// 		}
					// 	}
					// }
					journalTransaction.journalEntry = healthJournals.find(
						(healthJournal) =>
							healthJournal.id === journalTransaction.healthjournalId
					);
				} else if (journalTransaction.type === 'problem') {
					// problem = this.problems.get(journalTransaction.healthjournalId);
					// problem.optionLabel = problem.patient_display_name;
					// journalTransaction.journalEntry = problem;
				}
				journalTransaction.comment = journalTransaction.text || '[no comment]';
				journalTransaction.position = tracker % 2 === 1 ? 'right' : 'left';
				previous = journalTransaction;
				tracker++;
			});
			setTransactions(journalTransactions);
		}
	}, [
		journalTransactions,
		isJournalTransactionsLoading,
		problems,
		isProblemsLoading,
		healthJournals,
		isHealthJournalsLoading,
	]);

	return (
		<div className="journal-history">
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			<ul className="timeline">
				<li data-datetime="Now" className="timeline-separator" />
				{transactions.map((transaction) => (
					<React.Fragment key={`${transaction.id}`}>
						{transaction.separatorLabel && (
							<li
								data-datetime={transaction.separatorLabel}
								className="timeline-separator"
							></li>
						)}
						<li
							className={cn({
								'timeline-inverted': transaction.position === 'right',
							})}
						>
							<div
								className={cn(
									'timeline-badge',
									`face-${transaction.wellbeing_scale}`
								)}
							>
								<img src={getWellnessFace(transaction.wellbeing_scale)} />
							</div>
							<TimelinePanel {...transaction} />
						</li>
					</React.Fragment>
				))}
				<li className="timeline-end" />
			</ul>
		</div>
	);
};

JournalHistory.propTypes = {
	patientId: PropTypes.number.isRequired,
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired,
};

export default JournalHistory;
